/* Copyright (c) 2021-2026, NVIDIA CORPORATION.  All rights reserved.
*
* NVIDIA CORPORATION and its licensors retain all intellectual property
* and proprietary rights in and to this software, related documentation
* and any modifications thereto.  Any use, reproduction, disclosure or
* distribution of this software and related documentation without an express
* license agreement from NVIDIA CORPORATION is strictly prohibited.
*/

/** This file was automatically generated. DO NOT MODIFY IT BY HAND. */

/* eslint-disable @typescript-eslint/naming-convention */

import { BridgeCommands } from '../../../src/bridge.commands';

import { Types } from '../../types/index';

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetState: BridgeCommands.Command<
    Types.Nvapp.Nvappinstall.UserAction,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvAppInstall',
    method: 'SetState',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const UIReady: BridgeCommands.Command<
    {},
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvAppInstall',
    method: 'UIReady',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetTheme: BridgeCommands.Command<
    {},
    Types.Nvapp.Nvappinstall.ThemeResult
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvAppInstall',
    method: 'GetTheme',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetBillboardParameters: BridgeCommands.Command<
    {},
    Types.Nvapp.Nvappinstall.BillboardParameters
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvAppInstall',
    method: 'GetBillboardParameters',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const RegisterFormNotification: BridgeCommands.Command<
    {},
    Types.Nvapp.Nvappinstall.InstallerState
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvAppInstall',
    method: 'RegisterFormNotification',
    persistent: true
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const RegisterProgressNotification: BridgeCommands.Command<
    {},
    Types.Nvapp.Nvappinstall.Progress
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvAppInstall',
    method: 'RegisterProgressNotification',
    persistent: true
};

export const Nvappinstall = {
SetState,
UIReady,
GetTheme,
GetBillboardParameters,
RegisterFormNotification,
RegisterProgressNotification
};
